<template>
    <div>
        <img src="~@/assets/images/gradient_load.gif" class="preloader" v-if="loading">

        <template v-else>
            <div class="col-sm-4">
                <button class="btn btn-outline-primary btn__back" @click="toggleBuildPreview">back</button>
                <h1>Build &amp; Preview</h1>
                <p>Your preview link is being generated - this usually takes a minute or so</p>
                <p><b>Preview link login details:</b></p>
                <p><b>Username:</b> bbc-test</p>
                <p><b>Password:</b> test</p>
                <button class="btn btn-primary" @click="openPreview">View preview link</button>
                <button class="btn btn-primary" @click="downloadBuild">Download build</button>
            </div>
        </template>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        
        name: 'buildPreview',

        props: ['toggleBuildPreview'],

        data() {
            return {
                loading: true,
                repositoryName: '',
                url: '',
                idToken: this.$store.getters['authToken']
            }
        },

        mounted() {
            var self = this; 

            this.repositoryName = this.$route.query.repository;
            this.url = 'http://' + this.repositoryName + ".staging.node-production.com";
				
            var myJson = JSON.stringify({
                'repositoryName': this.repositoryName
            }); 
            axios
                .post("https://fqwrgdp5j1.execute-api.eu-west-2.amazonaws.com/prod/tag", myJson, {
                    headers: {
                        Authorization: self.idToken,
                    }
                })
                .then(() => {
                    //TO-DO implement endpoint to check build progress before changing loaded to true
                    setTimeout(function(){
                        self.loading = false;
                    },4000)
                })
                .catch(err => console.error(err));
        },

        methods: {
            openPreview() {
                window.open(this.url, "_blank");
            },
            downloadBuild() {
                alert('This feature is a work in progress')
            }
        }
    }
</script>


<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}
	
	.preloader {
		position: absolute;
        top: 28%;
        right: 0;
        left: 0;
        margin: 0 auto;	
	}

    .btn{
        &__back{
            font-size: 1rem;
        }
        &:not(:last-of-type) {
		    margin-right: 15px;
	    }

    }
	
</style>